import { useCurrentUser } from "@hire/hooks/useCurrentUser";
import { useAuthorizations } from "@hire/providers/authorization";
import { Feature } from "@hire/schema";

export function useSalesOrRenewalLink() {
  const [user] = useCurrentUser();
  const company = user?.currentCompany;

  const isPro = company?.isPro;

  const { features } = useAuthorizations([
    Feature.JobSlots,
    Feature.JobSlotCheckout,
  ]);

  return isPro ||
    (features.get(Feature.JobSlots)?.granted &&
      !features.get(Feature.JobSlotCheckout)?.granted)
    ? "https://employers.welcometothejungle.com/speak-to-the-team"
    : "https://employers.welcometothejungle.com/upgrade-today";
}
